<div
  [matTooltipDisabled]="!needsTooltip(getDisplayName(item))"
  [matTooltip]="getDisplayName(item)"
  (click)="toggleSelection()"
  class="results-content-result-item"
  >
  <span>
    <span class="item-title">
      {{ getDisplayName(item) }}
    </span>
  </span>
  <span class="d-flex gingr-content__drawer-content__item__sufix delete-icon">
    <mat-icon class="icon" (click)="openDeleteItemModal(item); $event.stopPropagation()" aria-label="Delete conversation">delete</mat-icon>
  </span>
  @if (canBeSelected) {
    <span class="d-flex gingr-content__drawer-content__item__sufix delete-icon">
      <mat-checkbox (change)="toggleSelection()" [(ngModel)]="isSelected"></mat-checkbox>
    </span>
  }
</div>
